

























import Vue from 'vue';
import { Editor } from 'tiptap';
import editorConfig from '@/config/editor';
import { findTextNodes } from 'prosemirror-utils';

import { db } from '@/db/firestore';

export default Vue.extend({
  props: {
    noteid: String,
    thumbnail: Boolean,
    editable: Boolean,
  },
  data(): {
    editor: any;
    defaultExtensions: () => any[];
    title: string | null | undefined;
    lead: string | null | undefined;
    sharing: string | null | undefined;
  } {
    return {
      editor: null,
      defaultExtensions: editorConfig.defaultExtensions,
      title: '',
      lead: '',
      sharing: '',
    };
  },
  async created() {
    if (this.noteid !== undefined) {
      const note = await this.$store.getters.getNoteById(this.noteid);
      const doc = JSON.parse(note.doc);
      this.editor = new Editor({
        content: doc,
        extensions: [...this.defaultExtensions()],
      });
      const textNodes = findTextNodes(this.editor.view.state.doc);
      const texts = textNodes.map((nodeItem) => nodeItem.node.text);
      this.title = texts.length > 0 ? texts[0] : '';
      this.lead = texts.length > 1 ? texts[1] : '';
      this.sharing = note.sharing;
    }
  },
  mounted() {},
  beforeDestroy() {
    if (this.editor !== null) {
      this.editor.destroy();
    }
  },
});
